import SlickSlider from './../SlickSlider';

/**
 * Component: Secure Cards Plans
 */

export default class SecureCardsPlans {
    constructor() {
        this.selectors = {
            sliders: 'data-secure-cards-plans-slider'
        };

        this.$window = $(window);
        this.init();
    }

    createSliders() {
        this.$sliders.each((index, slider) => {
            var config = {
                rows: 0,
                mobileFirst: true,
                dots: true,
                arrows: false,
                centerMode: false,
                slidesToScroll: 1,
                initialSlide: 1,
                variableWidth: true,
                infinite: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        draggable: true,
                        arrows: false,
                        dots: true,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: 'unslick'
                }]
            };

            return new SlickSlider(slider, config);
        });
    }

    init() {
        this.$sliders = $('[' + this.selectors.sliders + ']');

        if (this.$sliders.length) {
            this.createSliders();
        }

        $(window).on('resize', function () {
            $(this.$sliders).each((index, slider) => {
                if ($(window).width() < '992') {
                    $(slider).slick('slick');
                } else {
                    $(slider).slick('unslick');
                }
            });
        });
    }
}
